
import { Home, List, CreditCard, Mail, Phone, Settings } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface NavMenuItemsProps {
  isMobile?: boolean;
}

export const NavMenuItems = ({ isMobile = false }: NavMenuItemsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const menuItems = [
    { label: t('nav.home'), href: "/", icon: Home },
    { label: t('nav.useCases'), href: "/#teams", icon: List },
    { label: t('nav.howItWorks'), href: "/#how-it-works", icon: Settings },
    { label: t('nav.pricing'), href: "/custom-price", icon: CreditCard },
    { label: t('nav.requestDemo'), href: "/request-demo", icon: Phone },
  ];

  const baseClassName = isMobile
    ? "block px-3 py-2 text-gray-100 hover:text-primary transition-colors flex items-center gap-2"
    : `text-gray-100 hover:text-primary transition-colors flex items-center gap-2 ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`;

  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (href.startsWith('/#')) {
      const targetId = href.split('#')[1];
      if (location.pathname !== '/') {
        navigate('/', { state: { scrollTo: targetId } });
      } else {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      {menuItems.map((item, index) => (
        <a
          key={index}
          href={item.href}
          className={baseClassName}
          onClick={handleClick(item.href)}
        >
          <item.icon className="w-4 h-4" />
          {item.label}
        </a>
      ))}
    </>
  );
};
